import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import Spinner from 'web/components/Spinner';
import { placeBid } from "redux/actions/postLoad";
import AlertModal from 'web/components/AlertModal';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import TextArea from 'web/components/form-elements/TextArea';
import AddressEdit from "web/components/AddressEdit";
import { dateConvertToEpoch } from "web/components/utils/dateToEpoch"
import RadioButton from 'web/components/form-elements/RadioButton';
import DatePicker from 'web/components/form-elements/DatePicker';
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import { Form, Formik, Field } from 'formik';
import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';

import {
  getInitialValues,
  VALIDATION_SCHEMA,
} from 'web/components/utils/placeAltBid';
import { Modal, ModalBody } from 'reactstrap';
import './makeOffer.scss';
import styled from 'styled-components'
import { fetchLanguageContentNew } from 'redux/actions/language';
import Summary from './Summary';

export default ({ isOpen, toggle, title, link, response, recurring, myPostType }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  let token = localStorage.getItem('token')
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  const [pleaceBidText, setPleaceBidText] = useState('')
  const [pickUpDeliverableArr, setPickUpDeliverableArr] = useState([])

  const storedData = useSelector((state) => state.storedData.payload);
  let authId = storedData?.authId

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const toggleModal = () => setModal(!modal);

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );


  const [addressResponse, setResponse] = useState({ payload: "", address: "" });
  const [userAddressResponse, setUserAddressResponse] = useState();

  const [isAlternateQuantity, setIsAlternateQuantity] = useState("alternateQtyNo");
  const [isAlternateMode, setIsAlternateMode] = useState("alternateModeNo");
  const [isAlternateDate, setIsAlternateDate] = useState("alternateDateNo");
  const [isDisableAlternateMode, setDisableAlternateMode] = useState(false)

  //to re-render delivery date-time section
  const [pickupKey, setPickupKey] = useState(0);
  const [deliverableKey, setDeliverableKey] = useState(0);


  useEffect(() => {
    if (response?.postType === "NEED") {//accountType === "Seller" || 
      setPleaceBidText(pageLanguageContents?.MakeOfferModal[1]?.Checkbox2)
    } else {
      setPleaceBidText(pageLanguageContents?.MakeOfferModal[0]?.Checkbox1)
    }

    if (response?.postType === "NEED") {
      if (response?.shippingMode !== 'DELIVERY') {
        setPickUpDeliverableArr([
          {
            value: 'DELIVERABLE',
            label: pageLanguageContents?.MakeOfferModal[3]?.Delivery
          }
        ])
      } else {
        setPickUpDeliverableArr([
          {
            value: 'PICK_UP',
            label: pageLanguageContents?.MakeOfferModal[2]?.Pickup
          }
        ])
      }
    } else {
      if (response?.shippingMode === 'DELIVERY') {
        setPickUpDeliverableArr([
          {
            value: 'PICK_UP',
            label: pageLanguageContents?.MakeOfferModal[2]?.Pickup
          }
        ])
      } else {
        setPickUpDeliverableArr([
          {
            value: 'DELIVERABLE',
            label: pageLanguageContents?.MakeOfferModal[3]?.Delivery
          }
        ])
      }
    }
  }, [pageLanguageContents])

  useEffect(() => {

  }, [])

  const handleSubmit = async (props) => {

    let pickup = props.values.pickUpDeliverable;
    let setbidTimeArr = props?.values?.deliveryWindowBegin.split(':')
    let startTime = props?.values?.deliveryWindowBegin
    if (startTime.length) {
      let setHours = setbidTimeArr[0]
      let setMinutes = setbidTimeArr[1]
      if (setbidTimeArr[0].length === 1) {
        setHours = 0 + setbidTimeArr[0]
      }
      if (setbidTimeArr[1].length === 1) {
        setMinutes = 0 + setbidTimeArr[1]
      }
      startTime = setHours + ':' + setMinutes
    }
    let pickupEndTimeArr = props?.values?.deliveryWindowEnd.split(':')
    let endTime = props?.values?.deliveryWindowEnd
    if (startTime.length) {
      let setHours = pickupEndTimeArr[0]
      let setMinutes = pickupEndTimeArr[1]
      if (pickupEndTimeArr[0].length === 1) {
        setHours = 0 + pickupEndTimeArr[0]
      }
      if (pickupEndTimeArr[1].length === 1) {
        setMinutes = 0 + pickupEndTimeArr[1]
      }
      endTime = setHours + ':' + setMinutes
    }

    let deliverableStartTime = startTime
    let deliverableEndTime = endTime

    let setPickupTimeArr = props?.values?.pickupWindowBegin?.split(':')
    let startPickupTime = props?.values?.pickupWindowBegin

    if (startPickupTime?.length) {
      let setHours = setPickupTimeArr[0]
      let setMinutes = setPickupTimeArr[1]
      if (setPickupTimeArr[0].length === 1) {
        setHours = 0 + setPickupTimeArr[0]
      }
      if (setPickupTimeArr[1].length === 1) {
        setMinutes = 0 + setPickupTimeArr[1]
      }
      startPickupTime = setHours + ':' + setMinutes
    }
    let setPickupEndTimeArr = props?.values?.pickupWindowEnd?.split(':')
    let pickupEndTimeVal = props?.values?.pickupWindowEnd
    if (pickupEndTimeVal?.length) {
      let setHours = setPickupEndTimeArr[0]
      let setMinutes = setPickupEndTimeArr[1]
      if (setPickupEndTimeArr[0].length === 1) {
        setHours = 0 + setPickupEndTimeArr[0]
      }
      if (setPickupEndTimeArr[1].length === 1) {
        setMinutes = 0 + setPickupEndTimeArr[1]
      }
      pickupEndTimeVal = setHours + ':' + setMinutes
    }

    let pickupStartTime = startPickupTime;
    let pickupEndTime = pickupEndTimeVal;

    if (pickup === "PICK_UP") {
      pickup = true
      deliverableStartTime = '';
      deliverableEndTime = ''
    } else {
      pickup = false;
      pickupStartTime = '';
      pickupEndTime = '';
    }

    let fromTimeValue = (pickupStartTime !== '') ? pickupStartTime : deliverableStartTime
    fromTimeValue = parseInt(fromTimeValue?.replace(":", ""));
    let toTimeValue = pickupEndTime ? pickupEndTime : deliverableEndTime
    toTimeValue = parseInt(toTimeValue?.replace(":", ""));
    if (!(toTimeValue > fromTimeValue)) {
      setModalContent(pickup ? "Pickup window time is invalid." : "Delivery window time is invalid.");
      setModalLink("");
      toggleModal();
      return
    }

    //quantity change
    let newQuantity = (isAlternateQuantity === "alternateQtyYes") ? props.values.quantity : (response?.lotDetails?.qtyPerLot ? response?.lotDetails?.qtyPerLot : 540)
    if (parseInt(newQuantity) < 1) {
      setModalContent('Quantity should be greater than 0.');
      setModalLink("");
      toggleModal();
      return
    }
    let addressObj = {
      locationName: props.values.name ? props.values.name?.trim() : props.values.name,
      address1: props.values.line1 ? props.values.line1?.trim() : props.values.line1,
      address2: props.values.line2 ? props.values.line2?.trim() : props.values.line2,
      city: props.values.city ? props.values.city?.trim() : props.values.city,
      state: props.values.state,
      zipCode: props.values.zip ? props.values.zip?.trim() : props.values.zip,
    }

    Object.keys(addressObj).forEach(key => {
      if (addressObj[key] === null || addressObj[key] === '') {
        delete addressObj[key];
      }
    });

    let data = {
      authId: authId || '',
      needId: response?.id,
      biddingType: 'ALTBID',
      bidPrice: props.values.offerPrice.split(",").join("").substring(1),
      requestedDate: isAlternateDate === "alternateDateNo" ? response?.requestedDate : props.values.deliveryDateCheckout,//dateConvertToEpoch(props.values.deliveryDateCheckout),
      shippingMode: props.values.pickUpDeliverable === "PICK_UP" ? 'PICKUP' : response?.shippingMode,
      appointmentStartTime: pickupStartTime ? pickupStartTime : deliverableStartTime ? deliverableStartTime : '',
      appointmentEndTime: pickupEndTime ? pickupEndTime : deliverableEndTime ? deliverableEndTime : '',
      qty: parseInt(newQuantity) || '',
      comment: props.values.comment,
      biddingAddress: addressObj || ''
    };

    Object.keys(data).forEach(key => {
      if (data[key] === null || data[key] === '') {
        delete data[key];
      }
    });

    let getResponse = await dispatch(placeBid(data, token));

    if (getResponse?.success) {
      setModalContent(getResponse?.data?.msg);
      if (response?.postType === "NEED") {
        setModalLink('/view-my-bids-on-pallet-needs');
      } else {
        setModalLink('/view-my-offers-on-pallet-inventory');
      }
      //setPostType(response?.postType);
      toggleModal();
    } else {
      if (getResponse.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(getResponse?.data?.error?.message || getResponse?.data?.message || getResponse?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const [pickUpDeliverableState, setPickUpDeliverable] = useState(true);

  const deliverable = () => {
    return (
      <MakeOfferForm key={deliverableKey}>
        <DateWrapper>
          <p>{pageLanguageContents?.MakeOfferModal[4]?.DeliveryDate}</p>
          <DatePicker
            name='deliveryDateCheckout'
            type="makeOffer"
            deliveryTime={response?.deliveryTime}
            response={response}

          />
        </DateWrapper>
        <TimeWrapper>
          <p>{pageLanguageContents?.MakeOfferModal[5]?.DeliveryTime}</p>
          <div>
            <TimePickerInput
              name='deliveryWindowBegin'
              type='time'
              prePopulateState={response}
              // editResponse={response}
              pickUpDeliverableState={pickUpDeliverableState}
              showErrorMessages={true}
            />

            <span>{pageLanguageContents?.MakeOfferModal[6]?.To}</span>
            <TimePickerInput
              name='deliveryWindowEnd'
              type='time'
              prePopulateState={response}
              // editResponse={response}
              pickUpDeliverableState={pickUpDeliverableState}
              showErrorMessages={true}
            />
          </div>
        </TimeWrapper>
      </MakeOfferForm>
    )
  }

  const pickup = () => {
    return (
      <MakeOfferForm key={pickupKey}>
        <DateWrapper>
          <p>{pageLanguageContents?.MakeOfferModal[7]?.PickupDate}</p>
          <DatePicker
            name='deliveryDateCheckout'
            type="makeOffer"
            deliveryTime={response?.deliveryTime}
            response={response}
          />
        </DateWrapper>
        <TimeWrapper>
          <p>{pageLanguageContents?.MakeOfferModal[8]?.PickupTime}</p>
          <div>
            <TimePickerInput
              name='pickupWindowBegin'
              type='time'
              prePopulateState={response}
              pickUpDeliverableState={pickUpDeliverableState}
              showErrorMessages={true}
            />

            <span>{pageLanguageContents?.MakeOfferModal[6]?.To}</span>
            <TimePickerInput
              name='pickupWindowEnd'
              type='time'
              prePopulateState={response}
              pickUpDeliverableState={pickUpDeliverableState}
              showErrorMessages={true}
            />
          </div>
        </TimeWrapper>
      </MakeOfferForm>
    )
  }

  const setAddressFunction = (type, props) => {
    props.setFieldValue('name', "")
    props.setFieldValue('line1', "")
    props.setFieldValue('line2', "")
    props.setFieldValue('city', "")
    props.setFieldValue('state', "")
    props.setFieldValue('zip', "")
    props.setFieldValue('timeZone', "")
  }

  let daysOfWeek = []
  const recurrenceTag = (response) => {
    let dayOfWeekVal = ''
    if (response?.orderRecurrence && response?.orderRecurrence?.pattern && response?.orderRecurrence?.pattern?.dayOfWeek) {
      if (response?.orderRecurrence?.pattern?.dayOfWeek === 'MONDAY') {
        dayOfWeekVal = 'M'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'TUESDAY') {
        dayOfWeekVal = ' T'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'WEDNESDAY') {
        dayOfWeekVal = ' W'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'THURSDAY') {
        dayOfWeekVal = ' Th'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'FRIDAY') {
        dayOfWeekVal = ' F'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'SATURDAY') {
        dayOfWeekVal = ' Sat'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'SUNDAY') {
        dayOfWeekVal = ' Sun'
      }
    }

    daysOfWeek = []

    if (response?.orderRecurrence && response?.orderRecurrence?.pattern && (response?.orderRecurrence?.pattern?.type === "WEEKLY" || response?.orderRecurrence?.pattern?.type === "RELATIVEMONTHLY" || response?.orderRecurrence?.pattern?.type === 'MONTHLY')) {
      for (let i = 0; i < response.orderRecurrence.pattern.daysOfWeek.length; i++) {
        if (response.orderRecurrence.pattern.daysOfWeek[i] === 'MONDAY') {
          daysOfWeek.push('M')
        } if (response.orderRecurrence.pattern.daysOfWeek[i] === 'TUESDAY') {
          daysOfWeek.push(' T')
        } if (response.orderRecurrence.pattern.daysOfWeek[i] === 'WEDNESDAY') {
          daysOfWeek.push(' W')
        } if (response.orderRecurrence.pattern.daysOfWeek[i] === 'THURSDAY') {
          daysOfWeek.push(' Th')
        } if (response.orderRecurrence.pattern.daysOfWeek[i] === 'FRIDAY') {
          daysOfWeek.push(' F')
        } if (response.orderRecurrence.pattern.daysOfWeek[i] === 'SATURDAY') {
          daysOfWeek.push(' Sat')
        } if (response.orderRecurrence.pattern.daysOfWeek[i] === 'SUNDAY') {
          daysOfWeek.push(' Sun')
        }
      }
    }

    if (response.orderRecurrence && response.orderRecurrence.pattern) {
      return <>
        <Heading>
          Recurring Order Requirements:
        </Heading>
        <div className="flow-column">
          {response.orderRecurrence.pattern.type === "DAILY" && <p>Daily,&nbsp;{response.orderRecurrence.range.endAfterOccurrences ? "After " + response.orderRecurrence.range.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(response.orderRecurrence.range.start).format("MM/DD/YYYY")}, {"Ending " + moment(response.orderRecurrence.range.endBy).format("MM/DD/YYYY")}</>}</p>}
          {response.orderRecurrence.pattern.type === "WEEKLY" && <p>Weekly,&nbsp;Every&nbsp;{daysOfWeek.join(',')},&nbsp;{response.orderRecurrence.range.endAfterOccurrences ? "After " + response.orderRecurrence.range.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(response.orderRecurrence.range.start).format("MM/DD/YYYY")}, {"Ending " + moment(response.orderRecurrence.range.endBy).format("MM/DD/YYYY")}</>}</p>}
          {response.orderRecurrence.pattern.type === "MONTHLY" && <p>Monthly,&nbsp;{daysOfWeek.length !== 0 ? <>Every&nbsp;{daysOfWeek.join(',')}</> : <>{response.orderRecurrence.pattern.dayOfMonth}th</>}&nbsp;{response.orderRecurrence.range.endAfterOccurrences ? "After " + response.orderRecurrence.range.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(response.orderRecurrence.range.start).format("MM/DD/YYYY")}, {"Ending " + moment(response.orderRecurrence.range.endBy).format("MM/DD/YYYY")}</>}</p>}
          {response.orderRecurrence.pattern.type === "RELATIVEMONTHLY" && <p>Monthly,&nbsp;{response.orderRecurrence.pattern.dayOfWeek && <>Every&nbsp;{dayOfWeekVal}</>}&nbsp;{response.orderRecurrence.range.endAfterOccurrences ? "After " + response.orderRecurrence.range.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(response.orderRecurrence.range.start).format("MM/DD/YYYY")}, {"Ending " + moment(response.orderRecurrence.range.endBy).format("MM/DD/YYYY")}</>}</p>}
        </div>
      </>
    }

  }


  let addressState = false;


  if (storedData?.data?.userRole === 'BROKER' && response?.postType === "NEED" && response?.shippingMode !== 'DELIVERY' && pickUpDeliverableState) {
    addressState = true
  } else if (storedData?.data?.userRole === 'BROKER' && response?.postType === "NEED" && response?.shippingMode === 'DELIVERY' && pickUpDeliverableState) {
    addressState = true
  }
  const updateAddressSection = (mode, props) => {
    if (mode === "alternateModeYes") {
      if (response?.shippingMode !== 'DELIVERY') {
        setPickUpDeliverable(false);
        if (props) {
          props.setFieldValue('pickUpDeliverable', 'DELIVERABLE')
        }
      } else {
        setPickUpDeliverable(true);
        if (props) {
          setAddressFunction('pickUp', props)
          props.setFieldValue('pickUpDeliverable', 'PICK_UP')
        }
      }
    } else {
      if (response?.postType === "NEED") {
        if (response?.shippingMode !== 'DELIVERY') {
          setPickUpDeliverable(true);
          if (props) setAddressFunction('pickUp', props)
          if (props) props.setFieldValue('pickUpDeliverable', 'PICK_UP')
        } else {
          setPickUpDeliverable(false);
          if (props) {
            props.setFieldValue('pickUpDeliverable', 'DELIVERABLE')
          }
        }
      } else {
        if (response?.shippingMode === 'DELIVERY') {
          setPickUpDeliverable(false);
          if (props) {
            setAddressFunction('delivery', props)
            props.setFieldValue('pickUpDeliverable', 'DELIVERABLE')
          }
        } else {
          setPickUpDeliverable(true);
          if (props) {
            props.setFieldValue('pickUpDeliverable', 'PICK_UP')
          }
        }
      }
    }
    setPickupKey(prevKey => prevKey + 1);
    setDeliverableKey(prevKey => prevKey + 1);
  }

  useEffect(() => {
    updateAddressSection(isAlternateMode, undefined)
  }, [])

  useEffect(() => {
    if (response?.postType === "NEED" && response?.shippingMode !== 'DELIVERY') {
      setDisableAlternateMode(true)
    }
  }, [isDisableAlternateMode])

  const tConvert = (time) => {
    if (time) {
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        time = time.slice(1);

        time[5] = +time[0] < 12 ? " AM" : " PM";
        time[0] = +time[0] % 12 || 12;
      }
      return time.join("");
    }
  }

  return (<>{response &&
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='makeOfferContainer'>
        <div className=''>
          <div className='header'>
            <Button handleClick={() => {
              setPickUpDeliverable('PICK_UP')
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>{response?.postType === "NEED" ?
              pageLanguageContents?.PalletDetails[26]?.MakeBid
              :
              pageLanguageContents?.PalletDetails[38]?.MakeOffer
            }
              {/* <p>Use the alternative bid selection to alter the quantity of your bid, alter the mode (pickup vs delivery), or alter the date if you need the pallets to be available outside of the sellers usual business days.</p> */}
              <p>Use the alternative bid selection to alter the quantity of the posting, alter the mode (pickup vs delivery), or alter the date that the buyer originally requested.</p>
              <Summary postDetail={response} myPostType={response?.postType} />
            </h3>
          </div>
          <ModalBody>
            <div className='placeBidBody'>
              {loaderVisible && <Spinner />}
              {response && <Formik
                initialValues={getInitialValues(response, addressState)}
                validationSchema={VALIDATION_SCHEMA(pageLanguageContents, addressState)}
                onSubmit={(values) => { }}>
                {(props) => {
                  const { isValid, dirty } = props;
                  return (
                    <>
                      <Form>
                        <div className="section">
                          <div className="row">
                            <div className="col-md-6 radioContainer">
                              <div className="mt-0">
                                <p>Alternate Quantity</p>
                              </div>
                              <div className='quantityDiv'>
                                <RadioContainer>
                                  <Field
                                    component={RadioButton}
                                    name="alternateQty"
                                    id="alternateQtyYes"
                                    defaultValue={isAlternateQuantity}
                                    onSelect={e => {
                                      setIsAlternateQuantity(e.target.value)
                                    }}
                                    label="Yes"
                                    checked={isAlternateQuantity === "alternateQtyYes"}
                                  />
                                  <Field
                                    component={RadioButton}
                                    name="alternateQty"
                                    id="alternateQtyNo"
                                    defaultValue={isAlternateQuantity}
                                    onSelect={e => {
                                      setIsAlternateQuantity(e.target.value)
                                    }}
                                    label="No"
                                    checked={isAlternateQuantity === "alternateQtyNo"}
                                  />
                                </RadioContainer>

                                {/* Add input box for alternate QTY */}
                                {isAlternateQuantity !== "alternateQtyNo" && <div>
                                  {response.offerLessQuantity ? (
                                    <NumberInput
                                      name="quantity"
                                      showErrorMessages={true}
                                      decimalScale={0}
                                      quantityVal={response?.lotDetails?.originalQty ? response?.lotDetails?.originalQty : 540}
                                      placeholder="Quantity*"
                                    />
                                  ) : (
                                    <NumberInput
                                      name="quantity"
                                      maxLength={5}
                                      showErrorMessages={true}
                                      decimalScale={0}
                                      quantityVal={response?.lotDetails?.originalQty ? response?.lotDetails?.originalQty : 540}
                                      placeholder="Quantity*"
                                    />
                                  )}
                                </div>}
                              </div>

                            </div>
                            <div className="col-md-6 radioContainer">
                              <div className="mt-0">
                                <p>Alternate Mode</p>
                              </div>
                              <div className='pickupDiv'>
                                <RadioContainer style={isDisableAlternateMode ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
                                  {response?.shippingMode === 'DELIVERY' && <Field
                                    component={RadioButton}
                                    name="alternateMode"
                                    id="alternateModeYes"
                                    defaultValue={isAlternateMode}
                                    onSelect={e => {
                                      setIsAlternateMode(e.target.value)
                                      updateAddressSection(e.target.value, props)
                                    }}
                                    label="Yes"
                                    checked={isAlternateMode === "alternateModeYes"}
                                  />}
                                  <Field
                                    component={RadioButton}
                                    name="alternateMode"
                                    id="alternateModeNo"
                                    defaultValue={isAlternateMode}
                                    onSelect={e => {
                                      setIsAlternateMode(e.target.value)
                                      updateAddressSection(e.target.value, props)
                                    }}
                                    label="No"
                                    checked={isAlternateMode === "alternateModeNo"}
                                  />
                                </RadioContainer>
                                {isAlternateMode !== "alternateModeNo" && <div className="row responsive" style={{ 'margin-top': '-16px' }}>
                                  <div className="col-12">
                                    <RadioContainer>
                                      {pickUpDeliverableArr &&
                                        pickUpDeliverableArr.map(
                                          (value, index) => (
                                            <div key={index}>
                                              <Field
                                                component={RadioButton}
                                                name="pickUpDeliverable"
                                                id={value.value}
                                                defaultValue={pickUpDeliverableArr[0].value}
                                                onSelect={(e) => {
                                                  if (e.target.value === "PICK_UP") {
                                                    //setAddressFunction('pickUp', props)
                                                    setPickUpDeliverable(true);
                                                  } else {
                                                    setAddressFunction('delivery', props)
                                                    setPickUpDeliverable(false);
                                                  }
                                                }}
                                                label={value.label}
                                                checked={isAlternateMode === "alternateModeYes"}
                                              />
                                            </div>
                                          )
                                        )}
                                    </RadioContainer>
                                  </div>
                                </div>}
                              </div>

                            </div>
                          </div>

                          <BidPrice>
                            <div className='row'>
                              <div className="col-md-6 radioContainer">
                                <div className="mt-0">
                                  <p>Alternate Date</p>
                                </div>
                                <div>
                                  <RadioContainer>
                                    <Field
                                      component={RadioButton}
                                      name="alternateDate"
                                      id="alternateDateYes"
                                      defaultValue={isAlternateDate}
                                      onSelect={e => {
                                        setIsAlternateDate(e.target.value)
                                      }}
                                      label="Yes"
                                      checked={isAlternateDate === "alternateDateYes"}
                                    />
                                    <Field
                                      component={RadioButton}
                                      name="alternateDate"
                                      id="alternateDateNo"
                                      defaultValue={isAlternateDate}
                                      onSelect={e => {
                                        setIsAlternateDate(e.target.value)
                                      }}
                                      label="No"
                                      checked={isAlternateDate === "alternateDateNo"}
                                    />
                                  </RadioContainer>
                                </div>
                              </div>
                              {/* For web responsive */}
                              <div className="col-md-6 web-view-menu">
                                <div className="mt-0">
                                  <p>Bid Price<span className='star'>*</span> (p/pal)</p>
                                </div>
                                <div className='price-container'>
                                  <NumberInput
                                    name="offerPrice"
                                    prefix={"$"}
                                    thousandSeparator={true}
                                    placeholder="Bid Price* (p/pal)"
                                    maxLength={8}
                                    decimalScale={2}
                                    decimalSeparator=","
                                    fixedDecimalScale
                                    showErrorMessages={true}
                                  />
                                </div>
                                {response.displayCostToMarket &&
                                  <div className="row align-items-center">
                                    <div className="col-md-12 col-sm-12 target-price-column">
                                      {response?.postType !== "NEED" ?
                                        response.basePrice ? <p>Target Price : ${response.basePrice.toFixed(2)} (p/pal)</p> : <p>Target Price : NA</p>
                                        :
                                        response.targetPrice ? <p>Target Price : ${response.targetPrice.toFixed(2)} (p/pal)</p> : <p>Target Price : NA</p>
                                      }
                                      {/* {recurrenceTag(response)} */}
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </BidPrice>
                          {isAlternateDate !== "alternateDateNo" && <>{(pickUpDeliverableState) ? pickup() : deliverable()}</>}

                          {/* For Mobile responsive */}
                          <BidPrice>
                            <div className='row mobile-menu'>
                              <div className="col-md-6">
                                <div className="mt-0">
                                  <p>Bid Price<span className='star'>*</span> (p/pal)</p>
                                </div>
                                <div className='price-container'>
                                  <NumberInput
                                    name="offerPrice"
                                    prefix={"$"}
                                    thousandSeparator={true}
                                    placeholder="Bid Price* (p/pal)"
                                    maxLength={8}
                                    decimalScale={2}
                                    decimalSeparator=","
                                    fixedDecimalScale
                                    showErrorMessages={true}
                                  />
                                </div>
                                {response.displayCostToMarket &&
                                  <div className="row align-items-center">
                                    <div className="col-md-12 col-sm-12 target-price-column">
                                      {response?.postType !== "NEED" ?
                                        response.basePrice ? <p>Target Price : ${response.basePrice.toFixed(2)} (p/pal)</p> : <p>Target Price : NA</p>
                                        :
                                        response.targetPrice ? <p>Target Price : ${response.targetPrice.toFixed(2)} (p/pal)</p> : <p>Target Price : NA</p>
                                      }
                                      {/* {recurrenceTag(response)} */}
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </BidPrice>
                          <div className="row">
                            <div className="col-12">
                              {recurrenceTag(response)}
                            </div>
                          </div>

                          {storedData?.data?.userRole === 'BROKER' && response?.postType === "NEED" && response?.shippingMode !== 'DELIVERY' && pickUpDeliverableState && <AddressEdit props={props} response={response} />}
                          {storedData?.data?.userRole === 'BROKER' && response?.postType === "NEED" && response?.shippingMode === 'DELIVERY' && pickUpDeliverableState && <AddressEdit props={props} response={response} />}
                          {storedData?.data?.userRole === 'BROKER' && response?.postType !== "NEED" && response?.shippingMode === 'DELIVERY' && !pickUpDeliverableState && <AddressEdit props={props} response={response} />}
                          {storedData?.data?.userRole === 'BROKER' && response?.postType !== "NEED" && response?.shippingMode !== 'DELIVERY' && !pickUpDeliverableState && <AddressEdit props={props} response={response} />}

                          <div className="row">
                            <div className="col-12">
                              <div className="my-2">
                                <p>
                                  {pageLanguageContents?.MakeOfferModal[12]?.Message}
                                  <span className="star">
                                    *
                                  </span>
                                </p>
                              </div>
                              <TextAreaWrapper>
                                <TextArea
                                  name="comment"
                                  maxLength="250"
                                  showErrorMessages={true}
                                />
                              </TextAreaWrapper>
                            </div>
                          </div>

                          {response?.unLoadingReq === "LIVE_UNLOAD" && response?.shippingMode !== 'PICKUP' && response?.appointmentType === "REQUEST_DELIVERY_APPOINTMENT" &&
                            <div className="row ">
                              <div className="col-12 align-items-end d-flex">
                                <p>The Requested delivery appointment is at {tConvert(response?.appointmentStartTime)}</p>
                              </div>
                            </div>}

                          {/* {localStorage.getItem('brokerAccount') === 'brokerAc' && <AddressEdit props={props} response={response} />} */}
                          <div className="row" style={{ marginTop: '12px' }}>
                            <div className="col-12 align-items-end d-flex">
                              <div className="field FormCheckBox">
                                <CheckboxInput
                                  name="confirmBid"
                                  label={pleaceBidText}
                                  handleSelect={() => { }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="btnSection">
                              <Button
                                type="app-green-button"
                                name="createGroup"
                                handleClick={() => {
                                  handleSubmit(props);
                                }}
                                disabled={!(isValid && dirty)}
                              >
                                {pageLanguageContents?.MakeOfferModal[13]?.Confirm}{" "}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </>
                  );
                }}
              </Formik>}
            </div>
          </ModalBody>
        </div>
      </Modal>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        content={modalContent}
        link={modalLink === '/view-my-bids-on-pallet-needs' ? "" : modalLink}
        alertType={modalLink === '/view-my-bids-on-pallet-needs' ? "MyOfferPostBids" : ""}
        postType="PostLoad"
        postCallBackAlert={() => {
          let obj = {
            postType: "PostLoad",
            type: "bidsPalletNeeds",
            activePage: 'PostLoad',
            expanded: 'panel2'
          }
          dispatch({ type: 'BID_NEEDS', payload: obj })

          history.push({
            pathname: '/view-my-bids-on-pallet-needs',
          })
        }}
      />
    </div>
  }</>);
};




const MakeOfferForm = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;
    margin: 0 0 20px;
`
const TimeWrapper = styled.div`
flex: 1;
.app-input-text {
    margin-bottom: 0;
}
    > div {
        display: flex;
        align-items: center;
        gap: 15px;
        > div {
            min-width: 110px;
        }
    }
`
const DateWrapper = styled.div`
  max-width: 195px;
  width: 100%;
  min-width: 160px;
  flex: 1;
  @media (max-width: 540px) {
    max-width: 100%;
  }
`;

const RadioContainer = styled.div`
display: flex;
grid-column-gap: 40px;
grid-row-gap: 20px;
align-items: center;
margin-top: 15px;
margin-bottom: 15px;
 label{
    text-align:initial;
}
@media(max-width:767px){
    /* flex-direction: column; */
    align-items: flex-start;
}
`
const TextAreaWrapper = styled.div`
.app-input-text {
    margin-bottom: 0;
    textarea{
        height: 72px;
    }
}
`;
const Heading = styled.p`
  color: #000000;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  Button {
    color: #00b3ff;
    background: #ffffff;
    font-size: 20px;
  }
`;
const BidPrice = styled.p`
  .web-view-menu {
    display: block;
  }
  
  .mobile-menu {
    display: none;
  }

  @media screen and (max-width: 767px) {
  .web-view-menu {
    display: none;
  }
  
  .mobile-menu {
    display: block;
  }
}
`;

